<template>
    <div>
        <label>
            <input v-if="essential" type="checkbox" :id="id" checked="checked" disabled="disabled" />
            <input v-else type="checkbox" :id="id" />
            <span class="orange bold text-18">{{ title }}</span>
        </label>
        <div>
            {{ desc }}
            <div>
                <span v-for="service in services" class="green">
                    {{ service }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        id: '',
        title: '',
        desc: '',
        services: Array,
        service:{
            default() {
                return []
            }
        },
        essential: Boolean,
        essential: false,
    },
    data: () => {
        return {

        }
    }
}

</script>